/**
 * Entity types supported by the Universal Vision system
 */
export var VisionEntityType;
(function (VisionEntityType) {
    VisionEntityType["DISH"] = "DISH";
    VisionEntityType["EQUIPMENT"] = "EQUIPMENT";
    VisionEntityType["FOOD_LABEL"] = "FOOD_LABEL";
    VisionEntityType["FOOD_BARCODE"] = "FOOD_BARCODE";
    VisionEntityType["PHYSICAL_ACTIVITY"] = "PHYSICAL_ACTIVITY";
    VisionEntityType["BEVERAGE"] = "BEVERAGE";
})(VisionEntityType || (VisionEntityType = {}));
/**
 * Component relation types for entity decomposition
 */
export var ComponentRelationType;
(function (ComponentRelationType) {
    ComponentRelationType["INGREDIENT"] = "INGREDIENT";
    ComponentRelationType["PART"] = "PART";
    ComponentRelationType["ACCESSORY"] = "ACCESSORY";
})(ComponentRelationType || (ComponentRelationType = {}));
/**
 * Catalog entry types — controls portion handling in scan responses
 */
export var CatalogType;
(function (CatalogType) {
    CatalogType["DISH"] = "DISH";
    CatalogType["DRINK"] = "DRINK";
})(CatalogType || (CatalogType = {}));
